<template>
  <div class="app-container">
    <router-view />
    <TabBar />
  </div>
</template>

<script>
import TabBar from '../gba/components/tabBar.vue';

export default {
  name: 'GBALayout',
  components: {
    TabBar,
  },
};
</script>

<style scoped lang="scss">
.app-container {
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
